import React, { Component } from 'react';
import { Container } from 'reactstrap';
import SectionTitle from '../../components/Shared/SectionTitle';
import { Link } from 'react-router-dom';
import logodark from '../../assets/images/logo-dark.jpeg';

export default class About extends Component {

  render() {
    return (
      <React.Fragment>
        <Container className={'mt-60'}>
          <div className={'text-center mb-4'}>
            <Link to="#" className="logo-footer align-center">
              <img
                src={logodark}
                height="200"
                alt=""
                className={'rounded'}
              />
            </Link>
          </div>


          <SectionTitle
            title="Who We Are"
            desc="Diligent Staffing Kenya Limited is a duly registered and licensed recruitment agency in Kenya. We are registered and regulated by NEA and are members of ASMAK and KAPPEA.

We have also registered two job partnership portals: MUSADE and INJAZ.

We offer overseas job opportunities in Poland, Turkey, Portugal, Czech Republic, Slovakia, Serbia, Germany, Montenegro, Qatar, Dubai (UAE), and Kuwait.
"
          />
        </Container>
      </React.Fragment>
    );
  }
}
